import dashboardAuthReducer from './auth';
import dashboardVideoGraphers from './videoGrapher';
import dashboardVideos from './videos';
import dashboardCategoryTours from './categoryTours';
import dashboardTours from './tours';
import dashboardInvoices from './invoices';

import dashboardInit from './init';

export { dashboardAuthReducer, dashboardInit, dashboardVideoGraphers, dashboardVideos, dashboardCategoryTours, dashboardTours, dashboardInvoices };
